import {
    addMFA as addMFAService,
    resendPhoneVerificationCode as resendPhoneVerificationCodeService,
    verifyPhone,
} from '../../../services';

import { AUTH_STATES } from '/b2b/authentication/constants';
import AuthActions from '../../../state/Auth.actions';

export const resendPhoneVerificationCode = params => dispatch => {
    dispatch(AuthActions.resendPhoneVerificationCodeBegin(params));

    return resendPhoneVerificationCodeService(params)
        .then(response => {
            return dispatch(AuthActions.resendPhoneVerificationCodeSuccess(params, response));
        })
        .catch(error => {
            const { message } = error;
            dispatch(AuthActions.resendPhoneVerificationCodeFailure(params, error));

            throw message;
        });
};

export const addMFA = mfaType => dispatch => {
    dispatch(AuthActions.setPreferredMfaBegin(mfaType));

    return addMFAService(mfaType)
        .then(response => {
            dispatch(AuthActions.setPreferredMfaSuccess(mfaType, response));
            /** PINKY */
            dispatch(AuthActions.updateAuthState(AUTH_STATES.signedIn));
        })
        .catch(error => {
            const { message } = error;
            dispatch(AuthActions.setPreferredMfaFailure(mfaType, message));

            throw message;
        });
};

export const verify = params => dispatch => {
    dispatch(AuthActions.verifyPhoneBegin(params));

    return verifyPhone(params)
        .then(response => {
            dispatch(AuthActions.verifyPhoneSuccess(params, response));

            return addMFA('SMS')(dispatch);
        })
        .catch(error => {
            const { message } = error;
            dispatch(AuthActions.verifyPhoneFailure(params, message));

            throw message;
        });
};
